export default __webpack_public_path__ + "static/media/i064hk.475bacdb.webp";